import { render, staticRenderFns } from "./PainelInsercao.vue?vue&type=template&id=29745c0d"
import script from "./PainelInsercao.vue?vue&type=script&lang=js"
export * from "./PainelInsercao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports